module.exports = __webpack_public_path__ + "static/media/Mapa-Pernambuco.786e146a.svg";